module.exports = __webpack_public_path__ + "static/media/download-appstore-ic.d096e832.svg";